
/* WOMEN SPOT — FULL IMAGE HERO SLIDER */

(function () {
  'use strict';

  function initHero(root) {
    if (!root || root.dataset.initialized === 'true') return;

    const slides = Array.from(
      root.querySelectorAll('[data-wsh-slide]')
    );

    if (!slides.length) return;

    root.dataset.initialized = 'true';

    const dots = Array.from(
      root.querySelectorAll('[data-wsh-dot]')
    );

    const prev = root.querySelector('[data-wsh-prev]');
    const next = root.querySelector('[data-wsh-next]');
    const play = root.querySelector('[data-wsh-play]');

    const autoplay = root.dataset.autoplay === 'true';
    const speed = Math.max(3000, Number(root.dataset.speed) || 5000);

    const motion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    let index = 0;
    let timer = null;
    let hovered = false;
    let paused = motion.matches;
    let restartTimer = null;

    function stop() {
      if (timer !== null) {
        clearInterval(timer);
        timer = null;
      }
    }

    function show(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        const active = i === index;
        slide.hidden = !active;
        slide.inert = !active;
        slide.classList.toggle('is-active', active);
      });

      dots.forEach(function (dot, i) {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
    }

    function start() {
      stop();

      if (
        !root.isConnected ||
        !autoplay ||
        paused ||
        hovered ||
        document.hidden ||
        slides.length < 2 ||
        root.contains(document.activeElement)
      ) return;

      timer = setInterval(function () {
        show(index + 1);
      }, speed);
    }

    function updatePlay() {
      if (!play) return;

      play.textContent = paused ? 'Play' : 'Pause';
      play.setAttribute(
        'aria-label',
        paused
          ? 'Start automatic slideshow'
          : 'Pause automatic slideshow'
      );
    }

    prev?.addEventListener('click', function () {
      show(index - 1);
      start();
    });

    next?.addEventListener('click', function () {
      show(index + 1);
      start();
    });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(Number(dot.dataset.wshDot));
        start();
      });
    });

    play?.addEventListener('click', function () {
      paused = !paused;
      updatePlay();
      start();
    });

    root.addEventListener('mouseenter', function () {
      hovered = true;
      stop();
    });

    root.addEventListener('mouseleave', function () {
      hovered = false;
      start();
    });

    root.addEventListener('focusin', stop);

    root.addEventListener('focusout', function () {
      clearTimeout(restartTimer);
      restartTimer = setTimeout(start, 0);
    });

    function visibilityChanged() {
      start();
    }

    function motionChanged(event) {
      if (event.matches) {
        paused = true;
        updatePlay();
        stop();
      }
    }

    function selectBlock(event) {
      if (!root.contains(event.target)) return;

      const slide = event.target.closest('[data-wsh-slide]');
      const selectedIndex = slides.indexOf(slide);

      if (selectedIndex < 0) return;

      paused = true;
      show(selectedIndex);
      updatePlay();
      stop();
    }

    function deselectBlock(event) {
      if (!root.contains(event.target)) return;

      paused = motion.matches;
      updatePlay();
      start();
    }

    function unload(event) {
      if (
        event.target !== root &&
        !event.target.contains(root)
      ) return;

      stop();
      clearTimeout(restartTimer);

      document.removeEventListener(
        'visibilitychange', visibilityChanged
      );
      document.removeEventListener(
        'shopify:block:select', selectBlock
      );
      document.removeEventListener(
        'shopify:block:deselect', deselectBlock
      );
      document.removeEventListener(
        'shopify:section:unload', unload
      );

      if (motion.removeEventListener) {
        motion.removeEventListener('change', motionChanged);
      } else if (motion.removeListener) {
        motion.removeListener(motionChanged);
      }

      root.dataset.initialized = 'false';
    }

    document.addEventListener(
      'visibilitychange', visibilityChanged
    );
    document.addEventListener(
      'shopify:block:select', selectBlock
    );
    document.addEventListener(
      'shopify:block:deselect', deselectBlock
    );
    document.addEventListener(
      'shopify:section:unload', unload
    );

    if (motion.addEventListener) {
      motion.addEventListener('change', motionChanged);
    } else if (motion.addListener) {
      motion.addListener(motionChanged);
    }

    show(0);
    updatePlay();
    start();
  }

  function initAll(scope) {
    if (!scope) return;

    if (scope.matches?.('[data-wsh-hero]')) {
      initHero(scope);
    }

    scope.querySelectorAll('[data-wsh-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
